import { createSlice } from "@reduxjs/toolkit";

export const all_user_farms = createSlice({
  name: "all_user_farms",
  initialState: {
    value: {
      status: false,
      data: [],
    },
  },
  reducers: {
    updateAllUserFarms: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    addNewFarm: (state, action) => {
      state.value.status = true;
      state.value.data = [...state.value.data, action.payload?.farm];
    },
    removeFarm: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.data];
      state.value.data.forEach((item, index) => {
        if (action.payload === item._id) {
          existingData.splice(index, 1);
        }
      });
      state.value.data = existingData;
    },
    resetFarmData: (state, action) => {
      state.value = {
        status: false,
        data: [],
      };
    },
  },
});

export const { updateAllUserFarms, addNewFarm, removeFarm, resetFarmData } =
  all_user_farms.actions;

export default all_user_farms.reducer;
